export interface PODCorrectionsRow {
    id: string;
    deliveryNoteNumber: string;
    productCode: string;
    purchaseOrderNumber: string;
    purchaseOrderLineNumber: string;
    factoryCommercialInvoiceNumber: string;
    transportEquipmentNumber: string;
    materialCountryOfOrigin: string;

    podNumber: string;
    quantity: number;
    destinationCountry: string;
    stpQualifier: string;
    stpCode: string;
    stpCodeMasterData: string;

    newPodNumber: string;
    newDestinationCountry: string;
    newStpCode: string;

    toBeDeleted: boolean;
}

export function podNumberHasChanged(row: PODCorrectionsRow): boolean {
    return !!row.newPodNumber && row.newPodNumber !== row.podNumber;
}

export function destinationCountryHasChanged(row: PODCorrectionsRow): boolean {
    return !!row.newDestinationCountry && row.newDestinationCountry !== row.destinationCountry;
}

export function stpCodeHasChanged(row: PODCorrectionsRow): boolean {
    return !!row.newStpCode && row.newStpCode !== row.stpCode;
}

export function podNumberIsRequired(row: PODCorrectionsRow): boolean {
    return !row.newPodNumber && !row.podNumber && (destinationCountryHasChanged(row) || stpCodeHasChanged(row));
}

export function destinationCountryIsRequired(row: PODCorrectionsRow): boolean {
    return !row.newDestinationCountry && !row.destinationCountry && (podNumberHasChanged(row) || stpCodeHasChanged(row));
}

export function stpCodeIsRequired(row: PODCorrectionsRow): boolean {
    return !row.newStpCode && !row.stpCode && !row.stpCodeMasterData && (podNumberHasChanged(row) || destinationCountryHasChanged(row));
}

export function newRowInError(row: PODCorrectionsRow): boolean {
    return podNumberIsRequired(row) || destinationCountryIsRequired(row) || stpCodeIsRequired(row);
}

export function rowIsDirty(row: PODCorrectionsRow): boolean {
    return (podNumberHasChanged(row) || destinationCountryHasChanged(row) || stpCodeHasChanged(row)) || row.toBeDeleted;
}